import React from 'react';
import { Form, ButtonGroup, ToggleButton } from 'react-bootstrap';

const CareSettingsSection = ({ formData, onChange }) => {
  // Options for Care Team Model: only two options.
  const careTeamModelOptions = [
    { value: 'Care Team Model', label: 'Care Team Model' },
    { value: 'Independent Practice', label: 'Independent Practice' },
  ];

  // Options for Preferred Settings: use "Office Based" instead of "Clinic".
  const preferredSettingsOptions = [
    { value: 'Hospital', label: 'Hospital' },
    { value: 'Ambulatory', label: 'Ambulatory' },
    { value: 'Office Based', label: 'Office Based' },
  ];

  const renderToggleButtonGroup = (
    name,
    groupLabel,
    options,
    selectedValues,
    infoText = '',
    inputType = 'checkbox',
    styleOverride = { minWidth: '140px' },
    variant = 'outline-secondary'
  ) => (
    <Form.Group controlId={name} className="mb-4">
      <Form.Label className="h6" style={{ fontWeight: 'bold', marginBottom: '0.5rem' }}>
        {groupLabel}
      </Form.Label>
      <ButtonGroup className="d-flex flex-wrap">
        {options.map((option, idx) => {
          const uniqueId = `${name}_${option.value}_${idx}`;
          const checked =
            inputType === 'radio'
              ? selectedValues === option.value
              : (selectedValues || []).includes(option.value);
          return (
            <ToggleButton
              key={uniqueId}
              id={uniqueId}
              type={inputType}
              variant={variant}
              name={name}
              value={option.value}
              checked={checked}
              onChange={onChange}
              className="m-1"
              style={styleOverride}
            >
              {option.label}
            </ToggleButton>
          );
        })}
      </ButtonGroup>
      {infoText && <Form.Text className="text-muted">{infoText}</Form.Text>}
    </Form.Group>
  );

  return (
    <>
      {renderToggleButtonGroup(
        'facilityPreferences.careTeamModel',
        'Preferred Care Model',
        careTeamModelOptions,
        formData.facilityPreferences.careTeamModel || '',
        '',
        'radio'
      )}
      {renderToggleButtonGroup(
        'facilityPreferences.preferredSettings',
        'Preferred Settings',
        preferredSettingsOptions,
        formData.facilityPreferences.preferredSettings || [],
        ''
      )}
    </>
  );
};

export default CareSettingsSection;
